import { teamMemberRoles, type CreateTeamMemberInputSchema } from "@adva/types";
import {
  enumOptions,
  type EntityFieldConfig,
} from "@/components/v2/entity-form-config";

export type TeamMemberFormValues =
  (typeof CreateTeamMemberInputSchema)["_output"];

export const TEAM_MEMBER_FIELDS: EntityFieldConfig<TeamMemberFormValues>[] = [
  { name: "first_name", label: "First name", control: "text" },
  { name: "last_name", label: "Last name", control: "text" },
  {
    name: "email",
    label: "Email",
    control: "email",
    required: true,
    placeholder: "name@example.com",
  },
  { name: "phone", label: "Phone", control: "tel" },
  {
    name: "role",
    label: "Role",
    control: "select",
    required: true,
    options: enumOptions(teamMemberRoles),
  },
  { name: "display_title", label: "Title", control: "text" },
];

export function teamMemberToFormValues(
  tm: Record<string, unknown> | undefined,
): Partial<TeamMemberFormValues> {
  if (!tm) return {};
  const str = (v: unknown): string | undefined =>
    typeof v === "string" && v.length > 0 ? v : undefined;
  return {
    first_name: str(tm.first_name),
    last_name: str(tm.last_name),
    email: str(tm.email) ?? "",
    phone: str(tm.phone),
    role: str(tm.role) as TeamMemberFormValues["role"],
    display_title: str(tm.display_title),
  };
}
